var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb__base-color-blue mb__login fixed"},[_c('img',{staticClass:"mb__image-fit-contain LoginLogo",attrs:{"src":"/images/logo.svg","width":"100%","height":"auto"}}),_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }